import { render, staticRenderFns } from "./VideoBlock.vue?vue&type=template&id=1d852d05&scoped=true"
import script from "./VideoBlock.vue?vue&type=script&lang=js"
export * from "./VideoBlock.vue?vue&type=script&lang=js"
import style0 from "./VideoBlock.vue?vue&type=style&index=0&id=1d852d05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d852d05",
  null
  
)

export default component.exports